var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM9.78877 16.6921L16.8604 12.6512C17.3643 12.3633 17.3643 11.6367 16.8604 11.3488L9.78877 7.30787C9.28878 7.02216 8.66667 7.38318 8.66667 7.95905V16.0409C8.66667 16.6168 9.28878 16.9778 9.78877 16.6921Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"0","y1":"0","x2":"24.9201","y2":"0.996805","gradientUnits":"userSpaceOnUse"},React.createElement("stop",{"stopColor":"#6366F1"})))]);
}

Video.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Video;

Video.default = Video;
